import { render, staticRenderFns } from "./GlobalLargeSpotlight.vue?vue&type=template&id=5406a3f8&scoped=true"
import script from "./GlobalLargeSpotlight.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalLargeSpotlight.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalLargeSpotlight.vue?vue&type=style&index=0&id=5406a3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406a3f8",
  null
  
)

export default component.exports